import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import {
  Avatar,
  Card,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import RippleButton from "../../../components/common/RippleButton";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { LoadingPanel } from "../../../components/layout/Loading";
import {
  deleteTourImage,
  getImageByTourID,
  getTourByID,
  TourImageUpload,
  updateTourOtherInfo,
} from "../services/tour.services";

import {
  clearTourImageID,
  decreaseActiveStep,
  setTourImageID,
} from "../tourSlice";
import {
  closeDialog,
  openDialog,
} from "../../../components/dialog/dialogSlice";
import ShadowCard from "../../../components/common/ShadowCard";
import FormRichTextField from "../../../components/formFields/FormRichTextField";
import { Typography } from "@progress/kendo-react-common";
import { BOOLEAN } from "../../../_contstants/common";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import FormCheckbox from "../../../components/formFields/FormCheckbox";
import FormTextField from "../../../components/formFields/FormTextField";
import FormTextArea from "../../../components/formFields/FormTextArea";
import FormMultiSelectionFiled from "../../../components/formFields/FormMultiSelectionFiled";
import { IItineraryFacility } from "../../ItineraryFacility/itineraryfacilityModel";
import { getAllItineraryFacility } from "../../ItineraryFacility/services/itineraryfacility.services";
import FormImageUpload from "../../../components/formFields/FormImageUpload";
import { Label } from "@progress/kendo-react-labels";
import IconButton from "../../../components/common/IconButton";
import { Button } from "@progress/kendo-react-buttons";
import { FaEye } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import IconComponent from "../../../components/common/IconComponent";
import AppDialog, {
  DialogCloseButton,
} from "../../../components/dialog/Dialog";
import FormFileUpload from "../../../components/formFields/FormFileUpload";
import { Tooltip } from "@progress/kendo-react-tooltip";

const OtherInfo: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const TourID = location.state?.TourID;
  const loading = useAppSelector((state) => state.tour.loading);
  const TourDetail = useAppSelector((state) => state.tour.TourDetail);
  const TourImageDetail = useAppSelector((state) => state.tour.TourImageDetail);
  const ItinearyFacilityList = useAppSelector(
    (state) => state.itinearyfacility.ItinearyFacilityList
  );

  const [initialValues, setInitialValues] = useState<any>(TourDetail);
  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setInitialValues(TourDetail);
  }, [TourDetail]);
  useEffect(() => {
    setFormKey(formKey + 1);
    setInitialValues({ ...TourDetail, ...TourImageDetail });
  }, [TourImageDetail]);

  useEffect(() => {
    if (TourID) {
      dispatch(getTourByID(TourID));
      dispatch(getImageByTourID(TourID));
    }
    dispatch(getAllItineraryFacility());

    return () => {
      dispatch(closeDialog());
    };
  }, []);

  type DocViewProps = {
    attachment: string;
  };

  const DocView: React.FC<DocViewProps> = (props) => {
    const handleOnEditClick = () => {
      window.open(props.attachment, "_blank");
    };
    return (
      <Tooltip anchorElement="target" position="top" parentTitle={true}>
        <Button
          style={{ height: 35 }}
          type="button"
          title="View"
          fillMode="flat"
          size="large"
          themeColor={"primary"}
          onClick={handleOnEditClick}
        >
          <IconComponent icon={FaEye} />
        </Button>
      </Tooltip>
    );
  };

  const handleDeleteImage = async (ID: number) => {
    dispatch(openDialog("deleteTourImage"));
    dispatch(setTourImageID(ID));
    // try {
    //   const response = await dispatch(deleteTourImage(ID));
    //   if (response?.meta?.requestStatus === "fulfilled") {
    //     dispatch(getImageByTourID(TourID));
    //   }
    // } catch (error) {
    //   console.error("Error deleting image:", error);
    // }
  };

  const handleSubmit = async (values: any) => {
    if (TourID) {
      const insertPayload = {
        ID: TourID ? +TourID : null,
        Inclusions: values?.Inclusions ? values?.Inclusions : "",
        Exclusions: values?.Exclusions ? values?.Exclusions : "",
        CancellationPolicy: values?.CancellationPolicy
          ? values?.CancellationPolicy
          : "",
        ShortDescription: values.ShortDescription
          ? values.ShortDescription
          : "",
        Overview: values.Overview ? values.Overview : "",
        TourInformation: values.TourInformation ? values.TourInformation : "",
        PackageInclude: values?.PackageInclude
          ? values?.PackageInclude.join(",")
          : "",
        IsWebsiteDisplay: values.IsWebsiteDisplay === 1,
        IsHimalyaTreks: values.IsHimalyaTreks ? values.IsHimalyaTreks : false,
        IsPopularPackage: values.IsPopularPackage
          ? values.IsPopularPackage
          : false,
        MetaTitle: values.MetaTitle ? values.MetaTitle : "",
        MetaKeywords: values.MetaKeywords ? values.MetaKeywords : "",
        MetaDescription: values.MetaDescription ? values.MetaDescription : "",
      };

      const ImageData = new FormData();
      if (values?.MainImage && typeof values?.MainImage !== "string") {
        const MainImage = values.MainImage[0]?.getRawFile();
        if (MainImage) ImageData.append("MainImage", MainImage);
      }
      if (values?.attachments && Array.isArray(values.attachments)) {
        values.attachments.forEach((image: any) => {
          if (image.attachment && typeof image.attachment !== "string") return;
          const file = image instanceof File ? image : image?.getRawFile();
          if (file) {
            ImageData.append("attachment", file);
          }
        });
      }
      const response = await dispatch(updateTourOtherInfo(insertPayload));
      if (response?.meta?.requestStatus === "fulfilled") {
        if (
          (typeof values?.MainImage !== "string" &&
            values?.MainImage?.length > 0) ||
          values.attachments?.length > 0
        ) {
          if (TourID) {
            ImageData.append("TourID", TourID);
          }
          await dispatch(TourImageUpload(ImageData));
        }
        navigate("/tour");
      }
    }
  };

  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <DeleteTourDialog />
      <Form
        key={formKey}
        onSubmit={handleSubmit}
        initialValues={initialValues}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 15, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem style={{ marginTop: 10 }} colSpan={3}>
                  <Typography.h4>Other Information</Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem
                  colSpan={3}
                  style={{ display: "flex", gap: 10 }}
                >
                  <Field
                    wrapperStyle={{ width: "100%" }}
                    name="Inclusions"
                    label="Inclusions"
                    placeholder="Inclusions"
                    component={FormRichTextField}
                    style={{ height: 150 }}
                  />
                  <Field
                    wrapperStyle={{ width: "100%" }}
                    name="Exclusions"
                    label="Exclusions"
                    placeholder="Exclusions"
                    component={FormRichTextField}
                    style={{ height: 150 }}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  colSpan={3}
                  style={{ display: "flex", gap: 10 }}
                >
                  <Field
                    wrapperStyle={{ width: "100%" }}
                    name="CancellationPolicy"
                    label="Cancellation Policy"
                    placeholder="Cancellation Policy"
                    component={FormRichTextField}
                    style={{ height: 160 }}
                  />
                  <Field
                    wrapperStyle={{ width: "100%" }}
                    name="Overview"
                    style={{ height: 160 }}
                    label="Overview"
                    component={FormRichTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  colSpan={3}
                  style={{ display: "flex", gap: 10 }}
                >
                  <Field
                    wrapperStyle={{ width: "100%" }}
                    style={{ height: 160 }}
                    name="TourInformation"
                    label="Tour Information"
                    component={FormRichTextField}
                  />
                  <Field
                    wrapperStyle={{ width: "100%" }}
                    style={{ height: 160 }}
                    name="ShortDescription"
                    label="Short Description"
                    component={FormRichTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ width: "100%" }}>
                  <Field
                    id={"PackageInclude"}
                    name={"PackageInclude"}
                    label={"Package Include"}
                    component={FormMultiSelectionFiled}
                    isSelectAll={true}
                    options={ItinearyFacilityList?.map(
                      (facility: IItineraryFacility) => {
                        return {
                          value: facility?.ID,
                          label: facility?.Name,
                        };
                      }
                    )}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <div
                    style={{
                      marginTop: "18px",
                      background: "#edeaea",
                      borderRadius: 10,
                      padding: "15px 10px",
                      fontWeight: 500,
                      color: "black",
                    }}
                  >
                    <Field
                      wrapperClassName="m-0"
                      labelClassName="ms-2"
                      name="IsHimalyaTreks"
                      maxLength="100"
                      label="Is Himalayan Trek"
                      component={FormCheckbox}
                    />
                  </div>
                </GridLayoutItem>
                <GridLayoutItem>
                  <div
                    style={{
                      marginTop: "18px",
                      background: "#edeaea",
                      borderRadius: 10,
                      padding: "15px 10px",
                      fontWeight: 500,
                      color: "black",
                    }}
                  >
                    <Field
                      wrapperClassName="m-0"
                      labelClassName="ms-2"
                      name="IsPopularPackage"
                      label="Is Popular Package"
                      maxLength="50"
                      component={FormCheckbox}
                    />
                  </div>
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`IsWebsiteDisplay`}
                    label="Is Website Display"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={BOOLEAN?.map((iswebsitedisplay: any) => {
                      return {
                        value: iswebsitedisplay?.value,
                        label: iswebsitedisplay?.label,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={2}></GridLayoutItem>
                <GridLayoutItem colSpan={3}>
                  <hr />
                </GridLayoutItem>
                <GridLayoutItem style={{ marginTop: 10 }} colSpan={3}>
                  <Typography.h4>Tour Images</Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    justifyContent="start"
                    name={`MainImage`}
                    label="Main Image"
                    type="file"
                    accept="image/*"
                    alternateName="Main Image"
                    component={FormImageUpload}
                  />
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    justifyContent="start"
                    name="attachments"
                    label="Attachment"
                    type="file"
                    accept="image/*"
                    alternateName="attachment"
                    component={FormFileUpload}
                    multiple
                  />
                </GridLayoutItem>
                {TourImageDetail.attachment &&
                  TourImageDetail.attachment.length > 0 && (
                    <GridLayoutItem colSpan={3}>
                      <Label
                        id={"attachment-label"}
                        // editorId={id}
                        className="k-form-label field-label fw-600"
                        style={{
                          margin: "20px 0 10px",
                        }}
                      >
                        {"Attachments List"}
                      </Label>
                      <GridLayout
                        style={{ marginRight: 50 }}
                        cols={[
                          {
                            width: "16.66%",
                          },
                          {
                            width: "16.66%",
                          },
                          {
                            width: "16.66%",
                          },
                          {
                            width: "16.66%",
                          },
                          {
                            width: "16.66%",
                          },
                          {
                            width: "16.66%",
                          },
                        ]}
                        gap={{
                          cols: 10,
                          rows: 10,
                        }}
                      >
                        {TourImageDetail.attachment.map((attachment: any) => (
                          <GridLayoutItem>
                            <Card
                              style={{
                                boxShadow: "4px 4px 20px 4px rgb(0 0 0 / 5%)",
                              }}
                            >
                              <GridLayout
                                cols={[
                                  {
                                    width: "100%",
                                  },
                                ]}
                                style={{
                                  padding: "10px",
                                }}
                              >
                                <GridLayoutItem
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Avatar
                                    style={{
                                      width: 45,
                                      height: 45,
                                      flexBasis: 45,
                                    }}
                                    rounded={"full"}
                                    type={"image"}
                                  >
                                    <img
                                      src={attachment.attachment}
                                      alt="attachment"
                                      width={200}
                                      height={200}
                                      style={{
                                        backgroundColor: "whitesmoke",
                                      }}
                                    />
                                  </Avatar>
                                  <DocView attachment={attachment.attachment} />
                                  <IconButton
                                    type="button"
                                    fillMode="flat"
                                    size="small"
                                    title="Delete"
                                    themeColor="error"
                                    onClick={() =>
                                      handleDeleteImage(attachment.ID)
                                    }
                                    icon={MdDelete}
                                    iconClassName="absolute-position"
                                    iconStyle={{ fontSize: "24px" }}
                                  />
                                </GridLayoutItem>
                              </GridLayout>
                            </Card>
                          </GridLayoutItem>
                        ))}
                      </GridLayout>
                    </GridLayoutItem>
                  )}
                {formRenderProps.valueGetter("IsWebsiteDisplay") === 1 && (
                  <>
                    <GridLayoutItem colSpan={3}>
                      <hr />
                    </GridLayoutItem>
                    <GridLayoutItem style={{ marginTop: 10 }} colSpan={3}>
                      <Typography.h4>Meta Information</Typography.h4>
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={3} style={{ width: "100%" }}>
                      <Field
                        name="MetaTitle"
                        label="Meta Title"
                        placeholder="Meta Title"
                        component={FormTextField}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={3} style={{ width: "100%" }}>
                      <Field
                        name="MetaKeywords"
                        label="Meta Keywords"
                        placeholder="Meta Keywords"
                        component={FormTextField}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={3}>
                      <Field
                        wrapperStyle={{ width: "100%" }}
                        name="MetaDescription"
                        label="Meta Description"
                        component={FormTextArea}
                        rows={2}
                      />
                    </GridLayoutItem>
                  </>
                )}
                <GridLayoutItem
                  colSpan={3}
                  style={{
                    textAlign: "end",
                    marginTop: "20px",
                    width: "100%",
                  }}
                >
                  <RippleButton
                    type="button"
                    fillMode="outline"
                    themeColor="primary"
                    style={{ marginRight: 10 }}
                    onClick={() => dispatch(decreaseActiveStep())}
                  >
                    Previous
                  </RippleButton>

                  <ButtonWithLoading
                    label={"Save & Go to Tour List"}
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || loading}
                    loading={loading}
                  />

                  <RippleButton
                    fillMode="solid"
                    themeColor="primary"
                    style={{ marginLeft: 10 }}
                    onClick={() => navigate("/tour")}
                  >
                    Go to Tour List
                  </RippleButton>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

const DeleteTourDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const TourID = location.state?.TourID;
  const TourImageID = useAppSelector((state) => state.tour.TourImageID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      try {
        const response = await dispatch(deleteTourImage(ID));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closeDialog());
          dispatch(clearTourImageID());
          if (TourID) {
            dispatch(getImageByTourID(TourID));
          }
        }
      } catch (error) {
        console.error("Error deleting image:", error);
      }
    }
  };

  return (
    <>
      {dialogName === "deleteTourImage" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Image"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Image?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(TourImageID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default OtherInfo;
